import type {
  PublicContactMethodKind,
  PublicContactMethodsResponse,
} from "../../../../../api/public/appointment-portal"

export type AppointmentPortalContactMethodHints = {
  emailMaskedValue: string | null
  phoneMaskedValue: string | null
}

const EMPTY_HINTS: AppointmentPortalContactMethodHints = {
  emailMaskedValue: null,
  phoneMaskedValue: null,
}

const normalizeMaskedValue = (value: string | null | undefined): string | null => {
  const text = value?.trim()

  return text || null
}

const findMaskedValueByKind = (
  response: PublicContactMethodsResponse | null | undefined,
  kind: PublicContactMethodKind,
): string | null => {
  if (!response?.available) return null

  const method = response.contact_methods.find(
    (entry) => entry.kind.toUpperCase() === kind.toUpperCase(),
  )

  return normalizeMaskedValue(method?.masked_value)
}

const findPhoneMaskedValue = (
  response: PublicContactMethodsResponse | null | undefined,
): string | null => {
  if (!response?.available) return null

  const method = response.contact_methods.find((entry) =>
    ["MOBILE", "FIXED_LINE"].includes(entry.kind.toUpperCase()),
  )

  return normalizeMaskedValue(method?.masked_value)
}

export const buildAppointmentPortalContactMethodHints = (
  response: PublicContactMethodsResponse | null | undefined,
): AppointmentPortalContactMethodHints => {
  if (!response?.available) return EMPTY_HINTS

  return {
    emailMaskedValue: findMaskedValueByKind(response, "EMAIL"),
    phoneMaskedValue: findPhoneMaskedValue(response),
  }
}

export const buildAppointmentPortalEmailPlaceholder = (
  hints: AppointmentPortalContactMethodHints | null | undefined,
): string =>
  hints?.emailMaskedValue
    ? `E-Mail - gespeichert: ${hints.emailMaskedValue} (optional)`
    : "E-Mail (optional)"

export const buildAppointmentPortalPhonePlaceholder = (
  hints: AppointmentPortalContactMethodHints | null | undefined,
): string =>
  hints?.phoneMaskedValue
    ? `Telefon - gespeichert: ${hints.phoneMaskedValue} (optional)`
    : "Telefon (optional)"
